import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './styles/UI-kit/styles.scss';
import './locals/index'
import App from './App';
import reportWebVitals from './reportWebVitals';
import { SnackbarProvider } from 'notistack';
import { SnackbarUtilsConfigurator } from './components/NotistackPlus';
import { LicenseInfo } from '@mui/x-license-pro';
import {StyledEngineProvider} from "@mui/material";


LicenseInfo.setLicenseKey(process.env.REACT_APP_MUI_LICENSE_KEY as string)

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  // <React.StrictMode>
  //   <App />
  // </React.StrictMode>
    <StyledEngineProvider injectFirst>
    <SnackbarProvider maxSnack={1} anchorOrigin={{ vertical: 'top', horizontal: 'center' }}>
      <SnackbarUtilsConfigurator />
      <App />
    </SnackbarProvider>
    </StyledEngineProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
